import { FC } from 'react'
import styles from './index.module.scss'

type Props = {
  name: string
  text: string
}

export const AdFormatSubContent: FC<Props> = ({ name, text }) => {
  return (
    <div className={styles.container}>
      <p>
        <strong>{name}:&nbsp;</strong>
        {text}
      </p>
    </div>
  )
}
